module.exports = __webpack_public_path__ + "img/Custom Stickers.7b7fbf81.svg";